import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EditedCellsRubrica {
	[key: string]: string | number | boolean;
	title: string;
	dataIndex: number;
	key: number;
	keyRegistro: string;
}

const initialState: EditedCellsRubrica[] = [];

const rubricaDataPuntajeStateSlice = createSlice({
	name: 'rubricaDataPuntajeState',
	initialState,
	reducers: {
		setDataPuntajeRubrica: (state, action: PayloadAction<EditedCellsRubrica>) => {
			return [action.payload];
		},
		updateDataPuntajeRubrica: (state, action: PayloadAction<{ keyRegistro: string; data: EditedCellsRubrica }>) => {
			const newArreglo = state?.map((fila) => {
				if (fila.keyRegistro === action.payload.keyRegistro) {
					return { ...fila, ...action.payload.data };
				}
				return fila;
			});
			return newArreglo;
		},
		resetDataRubricaPuntaje: () => {
			return initialState;
		}
	}
});

export const { setDataPuntajeRubrica, updateDataPuntajeRubrica, resetDataRubricaPuntaje } =
	rubricaDataPuntajeStateSlice.actions;

export default rubricaDataPuntajeStateSlice.reducer;
